module.exports = __webpack_public_path__ + "img/NL159.139cf12c.svg";